import React from 'react';
import classNames from 'classnames';
import { Link, LinkProps } from 'react-router-dom';
import DoubleArrayLeftIcon from 'icons/DoubleArrayLeft.icon';

import './BackLink.styles.scss';
import './BackLink.styles.responsive.scss';

type BackLinkProps = {
  to?: string;
} & Omit<LinkProps, 'to'>;

const BackLink: React.FC<BackLinkProps> = (props) => {
  const { className, to = '..', children, ...rest } = props;

  const classes = classNames('back-link', className);

  return (
    <Link to={to} className={classes} {...rest}>
      <DoubleArrayLeftIcon />
      {children}
    </Link>
  );
};

export default BackLink;
